<template>
  <div>
    <div
      v-if="parsedTimeline && parsedTimeline[0]"
      class="relative w-56 top-2"
    >

      <div
        v-for="(step, index) of parsedTimeline"
        :key=index
        class="relative w-full h-16 border-l-2 border-transparent"
      >

        <!-- line -->
        <div
          v-if="step.line"
          :class="step.line"
        />

        <!-- circle -->
        <div :class="step.circle">

          <!-- icon success -->
          <svg
            v-if="step.icon === 'check'"
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M5 13l4 4L19 7"
            />
          </svg>

          <!-- icon error -->
          <svg
            v-if="step.icon === 'error'"
            xmlns="http://www.w3.org/2000/svg"
            class="w-4 h-4 text-white"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </div>

        <div class="relative px-4 -top-2">
          <p
            :class="step.textClass"
          >
            {{ step.text }}
          </p>
          <p
            :class="step.subTextClass"
          >
            {{ step.subText }}
          </p>
        </div>
      </div>
    </div>

    <div
      v-if="!parsedTimeline || !parsedTimeline[0]"
      class="flex items-center justify-center w-56 h-48 text-sm font-normal text-gray-600 top-2 font-italic"
    >
      Histórico indisponível
    </div>

  </div>
</template>

<script>
import {
  PAYMENT_PENDING,
  PAYMENT_NOT_APPROVED,
  PAYMENT_REPROVED,
  CANCELED,
  FINISHED
} from '@/enum/enum.cluster.status'
export default {
  name: 'SimpleTimeLine',

  props: {
    timeline: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      parsedTimeline: [],
      ERROR_STATUS: [PAYMENT_NOT_APPROVED, CANCELED, PAYMENT_REPROVED],
      FIRST_STEPS: [PAYMENT_PENDING],
      LAST_STEPS: [CANCELED, FINISHED]
    }
  },

  created () {
    this.init()
  },

  methods: {
    init () {
      this.parsedTimeline = this.parseTimeline(this.timeline)
    },

    parseTimeline (timelineMos) {
      if (!timelineMos || !timelineMos.statuses) return []

      const hasError = this.getErrorStatusFromTimeline(this.ERROR_STATUS, timelineMos.statuses)

      const simpleTimeline = this.getSimpleTimeline(this.FIRST_STEPS, this.LAST_STEPS, timelineMos.statuses)

      const parsedTimeline = this.buildParsedTimeline(hasError, simpleTimeline)

      return parsedTimeline
    },

    getErrorStatusFromTimeline (errorStatus, timeline) {
      let hasError = false

      for (const element of timeline) {
        hasError = element.list.some(status => errorStatus.includes(status.cluster.toUpperCase()))
        if (hasError) {
          return hasError
        }
      }

      return hasError
    },

    getSimpleTimeline (firstSteps, lastSteps, timeline) {
      const steps = {
        first: null,
        middle: null,
        last: null
      }

      timeline.forEach(status => {
        for (const item of status.list) {
          if (firstSteps.includes(item.cluster.toUpperCase())) {
            steps.first = item
          } else if (lastSteps.includes(item.cluster.toUpperCase())) {
            steps.last = item
          } else {
            steps.middle = item
          }
        }
      })
      const timelineSimple = []
      Object.values(steps).forEach(step => {
        if (step) {
          timelineSimple.push(step)
        }
      })

      return timelineSimple
    },

    buildParsedTimeline (hasError, timeline) {
      const classes = {
        circle: {
          medium: 'w-4 h-4 absolute -top-2 -left-2 rounded-full -ml-px',
          big: 'w-6 h-6 absolute -top-2 -left-3 rounded-full flex justify-center items-center'
        },
        line: 'absolute h-16 -top-14 -left-0.5',
        text: 'text-md font-normal line-clamp-2',
        subText: 'text-sm font-normal text-gray-800 line-clamp-1'
      }

      const statuses = []

      timeline.forEach((step, index) => {
        const dateTimeChunks = new Date(step.event_date).toLocaleString('pt-BR', { hour12: false }).split(' ')
        const timeChunks = dateTimeChunks[1].split(':')
        timeChunks.splice(timeChunks.length - 1, 1)
        const date = dateTimeChunks[0]
        const time = timeChunks.join(':')
        const lineType = index > 0 ? classes.line : null
        const circleType = index === timeline.length - 1 ? classes.circle.big : classes.circle.medium

        statuses.push({
          text: step.resumido,
          subText: `${date} às ${time}`,
          subTextClass: classes.subText,
          circle: hasError ? `${circleType} bg-red-mobly` : `${classes.circle.big} bg-green-mobly`,
          line: lineType ? `${lineType} border-l-2  ${hasError ? 'border-red-mobly' : 'border-green-mobly'}` : null,
          textClass: hasError ? `${classes.text} text-red-mobly` : `${classes.text} text-green-mobly`,
          icon: hasError ? 'error' : 'check',
          date: step.event_date
        })
      })
      const sortedTimeline = statuses.sort((a, b) => {
        if (a.date < b.date) return -1
        if (b.date < a.date) return 1
        return 0
      })

      return sortedTimeline
    }
  }
}
</script>
